import React, { useState } from 'react';
import Reviews from 'images/icons/reviews.svg';
import ChartBox from 'components/ChartBox';
import BarChart from 'components/highcharts/BarChart';
import RetrospectTrendPopper from './RetrospectTrendPopper';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import round from 'lodash/round';

const RetrospectReviewDepth = ({
  reviews = 0,
  avgComments = 0,
  data,
  trendData,
  styleAexs,
  chartColor
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.REVIEWS_TREND
    });
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const tooltipLabels = ['Reviews', 'Avg Comments / Review'];

  const totalLine = {
    icon: Reviews,
    of: 'Reviews',
    sum: reviews,
    extraInfo: `${round(avgComments, 1)} avg comments per review`
  };
  const trendGraphTexts = {
    title: 'REVIEWS TREND',
    avg: 'avg reviews per sprint',
    tooltip: tooltipLabels
  };

  return (
    <ChartBox
      isOpen={!!anchorEl}
      title='Reviews'
      onIconClick={handleClick}
      totalLine={totalLine}
    >
      <BarChart
        tooltipLabels={tooltipLabels}
        data={data}
        barColor={chartColor}
        yProps={styleAexs}
        xProps={styleAexs}
      />
      <RetrospectTrendPopper
        texts={trendGraphTexts}
        icon={Reviews}
        data={trendData}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      />
    </ChartBox>
  );
};

export default RetrospectReviewDepth;
